import React from 'react';
import { Select as AntSelect } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.less';

const propsByVersion = {
  default: {
    size: 'middle',
    className: styles.default,
  },
  long: {
    size: 'middle',
    className: styles.long,
  },
  short: {
    size: 'middle',
    className: styles.short,
  },
};

const Select = ({ version, className, options, renderOption, optionProps, ...rest }) => {
  const { className: propsClassName = '', ...props } = propsByVersion[version];

  return (
    <AntSelect {...props} className={`${propsClassName} ${className}`} {...rest}>
      {(options || []).map(option => (
        <AntSelect.Option
          value={option.id || option.value}
          key={option.id || option.value}
          {...optionProps}
        >
          {renderOption(option)}
        </AntSelect.Option>
      ))}
    </AntSelect>
  );
};

Select.propTypes = {
  version: PropTypes.oneOf(['default', 'long', 'short']),
  className: PropTypes.string,
  options: PropTypes.array,
  renderOption: PropTypes.func,
  optionProps: PropTypes.object,
};

Select.defaultProps = {
  version: 'default',
  className: '',
  options: [],
  renderOption: option => option.value,
  optionProps: {},
};

export default Select;
